import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { DataService } from '../../shared/services/data.service';
import { SystemMessage } from '../models/system-message.model';

/** A backend that predates `closable` and `actions` sends neither. */
type SystemMessageResponse = Omit<SystemMessage, 'closable' | 'actions'> & Partial<Pick<SystemMessage, 'closable' | 'actions'>>;

function withDefaults(message: SystemMessageResponse): SystemMessage {
  return { ...message, closable: message.closable !== false, actions: message.actions ?? [] };
}

@Injectable({ providedIn: 'root' })
export class SystemMessageService {
  private readonly dataService = inject(DataService);

  /** Every announcement whose visibility window covers now. Empty when there is nothing to show. */
  public getActive(): Observable<SystemMessage[]> {
    return this.dataService.get<SystemMessageResponse[]>('api/system-messages/active').pipe(map((messages) => messages.map(withDefaults)));
  }
}
